// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"4a55e3cdce7f0aaa","5015":"f175e82cf6773c1f","5571":"f175e82cf6773c1f","6358":"55a268c9f702f018","8728":"f175e82cf6773c1f"}[chunkId] + ".css";
};